import { useCallback, useEffect, useMemo, useRef, useState } from "react";
export var useRecekOnixItemPicker = function (onChange, dataOptions, value, onBlur, disabled) {
    var isInitialScrollRef = useRef(false);
    var _a = useState(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var _b = useState(""), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = useState(value === null || value === void 0 ? void 0 : value.value), selectedValue = _c[0], setSelectedValue = _c[1];
    useEffect(function () {
        if (!isModalOpen) {
            setSelectedValue(value === null || value === void 0 ? void 0 : value.value);
        }
    }, [value === null || value === void 0 ? void 0 : value.value, isModalOpen]);
    var sortedOptions = useMemo(function () { return dataOptions; }, [dataOptions]);
    var filteredItems = useMemo(function () {
        if (!searchTerm.trim())
            return sortedOptions;
        var term = searchTerm.toLowerCase();
        return sortedOptions.filter(function (item) {
            var _a, _b, _c, _d;
            return ((_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(term)) !== null && _b !== void 0 ? _b : false) ||
                ((_d = (_c = item.description) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(term)) !== null && _d !== void 0 ? _d : false);
        });
    }, [sortedOptions, searchTerm]);
    var activeIndex = useMemo(function () {
        return selectedValue
            ? filteredItems.findIndex(function (item) { return item.value === selectedValue; })
            : -1;
    }, [filteredItems, selectedValue]);
    var selectedItem = useMemo(function () { return dataOptions.find(function (item) { return item.value === selectedValue; }); }, [dataOptions, selectedValue]);
    var openModal = useCallback(function () {
        if (disabled)
            return;
        setSelectedValue(value === null || value === void 0 ? void 0 : value.value);
        setSearchTerm("");
        isInitialScrollRef.current = true;
        setIsModalOpen(true);
    }, [disabled, value === null || value === void 0 ? void 0 : value.value]);
    var closeModal = useCallback(function () {
        setIsModalOpen(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [onBlur]);
    var handleConfirm = useCallback(function () {
        var item = dataOptions.find(function (i) { return i.value === selectedValue; });
        onChange(item);
        setIsModalOpen(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [onChange, selectedValue, dataOptions, onBlur]);
    var handleSearchChange = useCallback(function (e) {
        setSearchTerm(e.target.value);
    }, []);
    var handleItemSelect = useCallback(function (item) {
        setSelectedValue(item.value);
    }, []);
    var handleItemDoubleClick = useCallback(function (item) {
        onChange(item);
        setIsModalOpen(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [onChange, onBlur]);
    var handleListKeyDown = useCallback(function (e) {
        var itemCount = filteredItems.length;
        switch (e.key) {
            case "ArrowDown":
                e.preventDefault();
                if (itemCount === 0)
                    return;
                setSelectedValue(filteredItems[activeIndex < itemCount - 1 ? activeIndex + 1 : 0]
                    .value);
                break;
            case "ArrowUp":
                e.preventDefault();
                if (itemCount === 0)
                    return;
                setSelectedValue(filteredItems[activeIndex > 0 ? activeIndex - 1 : itemCount - 1]
                    .value);
                break;
            case "Home":
                e.preventDefault();
                if (itemCount === 0)
                    return;
                setSelectedValue(filteredItems[0].value);
                break;
            case "End":
                e.preventDefault();
                if (itemCount === 0)
                    return;
                setSelectedValue(filteredItems[itemCount - 1].value);
                break;
            case "Enter":
                e.preventDefault();
                if (selectedValue !== undefined) {
                    handleConfirm();
                }
                break;
            case "Escape":
                e.preventDefault();
                closeModal();
                break;
            default:
                break;
        }
    }, [filteredItems, activeIndex, selectedValue, handleConfirm, closeModal]);
    return {
        isModalOpen: isModalOpen,
        activeIndex: activeIndex,
        isInitialScrollRef: isInitialScrollRef,
        selectedItem: selectedItem,
        searchTerm: searchTerm,
        filteredItems: filteredItems,
        selectedValue: selectedValue,
        openModal: openModal,
        closeModal: closeModal,
        handleListKeyDown: handleListKeyDown,
        handleSearchChange: handleSearchChange,
        handleItemSelect: handleItemSelect,
        handleItemDoubleClick: handleItemDoubleClick,
        handleConfirm: handleConfirm,
    };
};
